import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 2 – The need to prioritise:
                                                ‘The 80:20 rule’
                                            </div>
                                            <p>Why is it that some ‘busy’ people never seem to finish what
                                                they’re busying about? The Pareto
                                                Principle (also called the ‘80:20 rule’) reveals that,
                                                generally, 80% of what we achieve results
                                                from only 20% of the effort we put into it! There’ll always be
                                                ‘too much to do’ if we don’t focus on
                                                the most immediate tasks, first. In other words, to be more
                                                effective, prioritise…</p>
                                            <div className="border_subtitle">Step 3 – How to prioritise</div>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport  people_active2 paraspace ilead_v_sport_new_task">
                                                <tbody>
                                                <tr>
                                                    <td width="50%" align="center" valign="top"
                                                        className="lightgreen"><p>High urgency and low
                                                        importance</p>

                                                        <textarea className="TaskTextArea1"
                                                                  rows="2"
                                                                  cols="2"
                                                                  name="HighUrgencyAndLowImportance"
                                                                  value={this.props.pageData?.HighUrgencyAndLowImportance}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                    <td width="50%" align="center" valign="top"
                                                        className="darkgreen"><p>High urgency and high
                                                        importance</p>

                                                        <textarea className="TaskTextArea1"
                                                                  rows="2"
                                                                  cols="2"
                                                                  name="HighUrgencyAndHighImportance"
                                                                  value={this.props.pageData?.HighUrgencyAndHighImportance}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="center" valign="top"
                                                        className="darkgreen"><p>Low urgency and low
                                                        importance</p>

                                                        <textarea className="TaskTextArea1"
                                                                  rows="2"
                                                                  cols="2"
                                                                  name="LowUrgencyAndLowImportance"
                                                                  value={this.props.pageData?.LowUrgencyAndLowImportance}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                    <td width="50%&quot;" align="center" valign="top"
                                                        className="lightgreen">
                                                        <p>Low urgency and high importance</p>

                                                        <textarea className="TaskTextArea1"
                                                                  rows="2"
                                                                  cols="2"
                                                                  name="LowUrgencyAndHighImportance"
                                                                  value={this.props.pageData?.LowUrgencyAndHighImportance}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>


                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1 zeroPaddingUl4">
                                                <ul className="greenbullet-list zeroPaddingUl5">
                                                    <li>Put each task on your ‘to do’ list in one of the boxes
                                                        on the table.
                                                    </li>
                                                    <li>Break them down into smaller, manageable bits with a
                                                        deadline for each bit.
                                                    </li>
                                                    <li>Assess (seriously, now!) whether the less urgent tasks
                                                        are, in fact, just distractions.
                                                    </li>
                                                    <li>If not, add them to the lower boxes on the table.</li>
                                                    <div>
                                                        <li className="zeroPaddingUl4">Get going with your
                                                            priorities!
                                                        </li>
                                                    </div>
                                                </ul>
                                            </div>
                                            <div className="border_subtitle">Step 4 – Ask for help</div>
                                            <p>If you really do have too much to do, then get some help. You may
                                                be able to delegate some items,
                                                or, if you’ve been given things to do by someone else, ask them
                                                to help you prioritise your
                                                workload in the time you have available. Much overload results
                                                from our saying ‘yes’ out of habit
                                                or because we want to appear helpful. If demand on your time is
                                                going to make you ineffective,
                                                however, you’re not doing yourself or anyone else any
                                                favours.</p>
                                            <div className="border_subtitle">Step 5 – Avoid distractions</div>
                                            <p>Here are the worst offenders:</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport ilead_v_sport_center tablesrink uiheading">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top"
                                                        className="green_curve green_curve1"
                                                        colSpan="2">Distractions and Solutions
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Emails</p>
                                                    </td>
                                                    <td width="80%" align="left" valign="top"
                                                        className="lightgreen"><p>Just because you can, you
                                                        really don’t have to reply to that message RIGHT NOW!
                                                        The best thing about speedy communications and other
                                                        techno wizardry is that
                                                        you can make it work around you. For now, you could turn
                                                        your screen alert off.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Colleagues</p>
                                                    </td>
                                                    <td width="80%" align="left" valign="top"
                                                        className="lightgreen"><p>Just let them know you need to
                                                        concentrate for a while and that you look forward
                                                        to catching up with them later. It’s not a big deal, we
                                                        all need a bit of time and
                                                        space from time to time to get on with important tasks.
                                                        You’ll understand when
                                                        they ask the same of you.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Ourselves</p>
                                                    </td>
                                                    <td width="80%" align="left" valign="top"
                                                        className="lightgreen"><p>It’s surprising, the things we
                                                        suddenly notice that need our attention, before
                                                        getting down to whatever it is we haven’t had time to do
                                                        yet! You may tell yourself
                                                        you’ll concentrate better once you’ve tidied the
                                                        cupboard/desk/room, or nipped
                                                        out to get that thing before stocks run out, but we know
                                                        it’s all nonsense. Just
                                                        think, once you really have done it, won’t that feel
                                                        good?</p>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}